import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles.css';
import ExpenseForm from './ExpenseForm';
import Header from './Header';
import expensePresets from '../config/expensePresets';
import { checkNoteStatus, submitExpense } from '../utils/expenseApiHandlers';
import { handleCancel, validateExpenseType } from '../utils/navigationHandlers';

function AddExpense({ handleLogout, goToHome }) {
  const { noteId, expenseType } = useParams();
  const navigate = useNavigate();
  const formId = `add-expense-form-${noteId}-${expenseType}`;
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitClick = () => {
    document.getElementById(formId)?.requestSubmit();
  };

  const handleSaveExpense = async (formData) => {
    setIsLoading(true);
    try {
      const isNoteValid = await checkNoteStatus(noteId);
      if (!isNoteValid) {
        setIsLoading(false);
        return;
      }

      const { success } = await submitExpense(formData);
      if (success) {
        navigate(`/get-expenses/${noteId}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!validateExpenseType(expenseType, expensePresets)) {
    return (
      <div className="error-container">
        <h2>Type de dépense invalide</h2>
        <button 
          onClick={() => navigate(`/get-expenses/${noteId}`)}
          className="back-button"
        >
          Retour aux notes de frais
        </button>
      </div>
    );
  }

  return (
    <div>
      <main className="add-expense-container">
        <ExpenseForm
          expenseType={expenseType}
          noteId={noteId}
          onSave={handleSaveExpense}
          onCancel={() => handleCancel(noteId, navigate)}
          formId={formId}
          showSubmitButton={false}
        />
      </main>

      <footer>
        <Header handleLogout={handleLogout} />
        <button
          type="button"
          className="footer-center-button footer-submit-button"
          aria-label="Ajouter la dépense"
          title="Ajouter la dépense"
          onClick={handleSubmitClick}
          disabled={isLoading}
        >
          <i className="fa-solid fa-plus"></i>
        </button>
        <button 
          className="footer-side-right-button" 
          onClick={() => navigate(`/get-expenses/${noteId}`)}
          aria-label="Annuler et revenir"
          title="Annuler et revenir"
          disabled={isLoading}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </footer>
    </div>
  );
}

export default AddExpense; 
